module.exports = __webpack_public_path__ + "static/media/no-groups.c490b6ff.png";